import React from 'react';
import { withRouter } from '../../../common/utils/NavigationWrapper';
import { TableCell, TableRow, TableBody, Table } from '@mui/material';
import Tile from '../../../common/components/Tile/Tile';
import './../../InstrumentDetails/components/InstrumentSummary/InstrumentSummary.css';

const DeviceSummary = (props) => {
  const { instrument } = props;

  return (
    <Tile className="instrument-summary" title="Device details" helpTag="device_summary">
      <Table data-qa="qa-instrument-summary">
        <TableBody>
          <TableRow>
            <TableCell style={{ width: '55%' }}>Serial number</TableCell>
            <TableCell style={{ marginLeft: 20 }}>{instrument.SerialNumber}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Product</TableCell>
            <TableCell>{instrument.Type ? instrument.Type : 'Not available'}</TableCell>
          </TableRow>
          {instrument.OperatingSystem ? (
            <TableRow>
              <TableCell>Operating System</TableCell>
              <TableCell>{instrument.OperatingSystem}</TableCell>
            </TableRow>
          ) : null}
          <TableRow>
            <TableCell>Software version</TableCell>
            <TableCell>
              {instrument.SoftwareVersion ? instrument.SoftwareVersion : 'Not available'}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>System cycle</TableCell>
            <TableCell>{instrument.CycleCount ? instrument.CycleCount : 'Not available'}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Connection</TableCell>
            <TableCell>{instrument.Connected ? 'Online' : 'Offline'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell>{instrument.Status ? instrument.Status : 'Not available'}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Tile>
  );
};

export default withRouter(DeviceSummary);
